import React from 'react';

type Props = {
    className?      : string,
    label?          : string
}

export default function GDLoadingBlock(props:Props) {

    const label = _.get(props,'label', "Loading...")

    return (
        <div className={Classes("gd-loading-block", props.className)}>
            <img className="loading-image" src={gdConfig.assetsPath + "/skin/common/loader/app-loading.gif?" + gdConfig.build} />
            <div className="loading-label">{label}</div>
        </div>
    );
}
